import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  lRoot: {
    width: "100%",
    flexDirection: "column",
    marginBottom: theme.spacing(2)
  }
}));
